import axios from 'axios'
import { Message } from 'element-ui'
import router from '@/router'
import Global from '../../config/global'

const requestService = axios.create({
  baseURL: Global.apiUrl,
  timeout: 0
})

// 请求拦截器
requestService.interceptors.request.use(
  config => {
    // 添加请求头部参数
    config.headers['token'] = localStorage.getItem('token')
    config.headers['Access-Control-Allow-Origin'] = '*'
    config.headers['Access-Control-Allow-Methods'] = 'POST, GET, OPTIONS, PUT, DELETE'
    config.headers['Access-Control-Allow-Headers'] = 'x-requested-with,content-type'
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
requestService.interceptors.response.use(
  response => {
    let res = response.data
    // 如果40表示访问受限，重新登入
    if (res.code === '4002' || res.code === '4009' || res.code === '4003') {
      localStorage.removeItem('token')
      router.replace({
        path: '/',
        query: {redirect: router.currentRoute.fullPath}
      })
      return res
    }
    if (res.code !== '0') {
      Message({
        showClose: true,
        message: res.msg ? res.msg : '访问失败',
        type: 'error'
      })
      return Promise.reject(new Error(res.msg ? res.msg : '访问失败'))
    }
    // 拦截到成功的数据
    return res
  },
  error => {
    // 拦截到失败的数据
    return Promise.reject(error)
  }
)

export default requestService



// WEBPACK FOOTER //
// ./src/util/request.js